<template>
  <div class="popup-open">
    <div class="popup-content">
      <div class="button-group">
        <div class="button-item" @click="handleClick('openThemePicker')">
          <i class="iconfont icon-skin-line" />
          <span>换肤</span>
        </div>
        <div class="button-item" @click="handleClick('interpretation')">
          <i class="iconfont icon-view_line" />
          <span>讲解方案</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APP_CHANNEL } from '@/common/utils/variables'
export default {
  name: 'PopupOpen',
  methods: {
    handleClick(type) {
      this.$emit('invoke', type);
    }
  }
}
</script>

<style lang="postcss" scoped>
.popup-open {
  position: absolute;
  bottom: calc(100% + 7px);
  height: 52px;
  border-bottom: 1px solid #f5f5f5;
  left: 0;
  right: 0;
  width: 100vw;
  max-width: 100vw;
  margin-left: -10px;
  box-sizing: border-box;
  padding: 0;
  background-color: #fff;
  z-index: 100;
}

.button-group {
  display: flex;
  justify-content: flex-start;
  padding-left: 10px;
  padding-top: 7px;
}

.button-group:last-child {
  margin-bottom: 0;
}

.button-item {
  display: flex;
  width: 55px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.button-item i {
  font-size: 21px;
  margin-bottom: 5px;
}

.button-item span {
  font-size: 10px;
  color: #333333;
}
</style>